import { connect } from 'react-redux';
import ScannerModal from '../../../components/scanner/ScannerModal';
import {
  loadingSearch,
  searchResults,
  resourcesReportOptions,
  aislesList,
  loadingReport,
} from 'core/selectors';
import { searchProduct, setReportParameters, resetSearch } from 'core/slices/search';
import { createTasks } from 'core/slices/tasks_modification';
import { getTasksProgress } from 'core/slices/tasks';
import { getAisles } from 'core/slices/aisles';

export default connect(
  (state) => ({
    loadingSearch: loadingSearch(state),
    searchResults: searchResults(state),
    resourcesReportOptions: resourcesReportOptions(state),
    aislesList: aislesList(state),
    loadingReport: loadingReport(state),
  }),
  {
    searchProduct,
    setReportParameters,
    resetSearch,
    createTasks,
    getAisles,
    getTasksProgress,
  },
)(ScannerModal);
